import { Challenge } from "./challenge";
import { KeyCode } from "../enums";

export class ViberpinChallenge extends Challenge {
    private refreshSrc = "";

    protected async execute(): Promise<boolean> {
        if (!this.processMdata()) {
            this.refreshSrc = this.core.conf.capi_refreshPng;
        }

        return true;
    }

    private keyHandler(event: KeyboardEvent) {
        if (event.key == KeyCode.Space || event.key == KeyCode.Enter) {
            this.core.loadChallenge.bind(this.core)();
        }
    }

    async render(parentDiv: HTMLElement): Promise<boolean> {
        const cres = this.getCresElement();
        const refreshBtn = document.createElement("img");
        const refreshDiv = document.createElement("div");

        if (!(await this.execute())) { return false; }

        refreshDiv.className = "c-refresh-div";
        refreshBtn.setAttribute("aria-label", "refresh");
        refreshBtn.tabIndex = 0;
        refreshBtn.setAttribute("role", "button");
        refreshBtn.className = "c-refresh";
        refreshBtn.classList.add("viber");
        refreshBtn.src = this.refreshSrc;

        const br = document.createElement("br");
        const br1 = document.createElement("br");
        br.className = "c-break";
        br1.className = "c-break";

        const inputHelpDiv = document.createElement("div");
        inputHelpDiv.className = "pin-input-help";
        inputHelpDiv.innerHTML = this.core.conf.getLocalization().viberPinDescription;

        cres.className = "c-pin-input";
        cres.setAttribute("aria-label", this.core.conf.getLocalization().viberPinDescription);
        cres.type = "text";
        cres.value = "";

        parentDiv.appendChild(inputHelpDiv);
        parentDiv.appendChild(cres);
        parentDiv.appendChild(br);
        parentDiv.appendChild(refreshDiv);
        refreshDiv.appendChild(refreshBtn);
        parentDiv.appendChild(br1);

        refreshDiv.onclick = this.core.loadChallenge.bind(this.core);
        refreshDiv.onkeydown = this.keyHandler.bind(this);

        return true;
    }

    protected processMdata(): boolean {
        if (this.mdata) {
            const viberMedia = this.mdata.split(",");
            if (viberMedia.length === Challenge.EXPECTED_MEDIA_LENGTH) {
                this.refreshSrc = Challenge.IMAGEDATA + viberMedia[1];
                return true;
            }
        }
        return false;
    }
}
